class customPagination extends HTMLElement {
    constructor() {
        super();
        this.scrollToElement = $("[data-scroll-to]");
        this.glossaryItem = $(".glossary-item");
        this.panelItem = $(".js-panel-item");
        this.paginationItem = $("[js-pagination-item]");
        this.prevBtn = $("[js-previous-btn]");
        this.nextBtn = $("[js-next-btn]");
        this.showPerPage = parseInt(this.dataset.showPerPage);
        this.endPage = parseInt(this.dataset.endPage);
        this.currentPage = 1;
        
        this.init();
    };
    
    init() {
        this.paginationItem.click((evt) => {
            evt.preventDefault();

            const target = $(evt.currentTarget);
            const currentPage = parseInt(target.data("page-number"));
            this.currentPage = currentPage;

            this.goToPage();
        });

        this.prevBtn.click(this.previous.bind(this));
        this.nextBtn.click(this.next.bind(this));
    };

    changeState() {
        this.paginationItem.removeClass("current");
        $(`[data-page-number="${this.currentPage}"]`).addClass("current");

        if(this.currentPage === 1) {
            this.prevBtn.addClass("disabled");
            this.nextBtn.removeClass("disabled");
        }else if(this.currentPage === this.endPage) {
            this.prevBtn.removeClass("disabled");
            this.nextBtn.addClass("disabled");
        }else {
            this.prevBtn.removeClass("disabled");
            this.nextBtn.removeClass("disabled");
        }
    };

    updateScroll() {
        $('html, body').animate({
            scrollTop: this.scrollToElement.offset().top - 56
        }, 500);
    };

    renderGlossary(start_from, end_on) {
        this.glossaryItem.addClass("hide");
        this.panelItem.addClass("hide");
        $('.glossary-list').each( (index,item) => $(item).children().slice(start_from, end_on).removeClass('hide'));
    };

    previous(evt) {
        evt.preventDefault();
        if($('.current').prev('.page').length){
            const new_page = this.currentPage - 1;
            this.currentPage = new_page;
            this.goToPage(new_page);
        }else {
            $('.current').addClass("disabled")
        }
    };

    next(evt) {
        evt.preventDefault();
        if($('.current').next('.page').length){
            const new_page = this.currentPage + 1;
            this.currentPage = new_page;
            this.goToPage(new_page);
        }else {
            $('.current').addClass("disabled")
        }
    };

    goToPage() {
        const start_from = (this.currentPage - 1) * this.showPerPage;
        const end_on = start_from + this.showPerPage;

        this.updateScroll();
        this.changeState();
        this.renderGlossary(start_from, end_on);
    };
};
  
customElements.define('custom-pagination', customPagination);